import { useDeleteUnresponsiveParties } from '@hooks/other/useDeleteUnresponsiveParties';
import { useUnresponsiveParties } from '@hooks/queries/deadtasks/useUnresponsiveParties';
import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import { CircularProgress, IconButton } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import PartyDisplay from '../../components/PartyDisplay';
import { DataTable } from '../../components/Table/DataTable';
import { UtilityBackend } from '../../utils/UtilityAutomationApiClient';
import { PageWrapper } from '../PageWrapper';

interface RemovePartyProps {
  party: string;
  backend: UtilityBackend;
}
const RemoveParty: React.FC<RemovePartyProps> = ({ party, backend }) => {
  const removeParties = useDeleteUnresponsiveParties();
  const onDelete = async () => {
    await removeParties.mutateAsync({ backend, partyIds: [party] });
  };
  if (removeParties.isLoading) {
    return <CircularProgress color="error" size={20} />;
  }
  return (
    <IconButton
      onClick={() => {
        onDelete()
          .then(() => {})
          .catch(() => {});
      }}
      size="small"
    >
      <DeleteIcon fontSize="small" color="error" />
    </IconButton>
  );
};

interface Row {
  partyId: string;
}
const createHeaders: () => GridColDef<Row>[] = () => {
  return [
    {
      field: 'party',
      headerName: 'party ID',
      flex: 2,
      renderCell: (params) => <PartyDisplay party={params.row.partyId} />,
    },
    {
      field: ' ',
      headerName: '',
      align: 'right',
      renderCell: (params) => (
        <RemoveParty backend={UtilityBackend.CREDENTIAL} party={params.row.partyId} />
      ),
    },
  ];
};
interface UnresponsivePartiesProps {
  disableVirtualization?: boolean;
  backend: UtilityBackend;
}
export const UnresponsiveParties: React.FC<UnresponsivePartiesProps> = ({
  disableVirtualization,
  backend,
}) => {
  const u = useUnresponsiveParties(backend);
  if (u.isLoading) {
    return <CircularProgress />;
  }
  const rows = u.data?.map((partyId) => ({ partyId }));
  return (
    <PageWrapper pageName="Unresponsive parties">
      <DataTable
        columns={createHeaders()}
        rows={rows || []}
        rowKey={(r) => r.partyId}
        disableVirtualization={disableVirtualization}
      />
    </PageWrapper>
  );
};
